(ns teamoesterreich.admin-mode.crowdtasker.event-user-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.selection.selection-table :as table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.eventMember :as d-eventMember]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.util.helper :as h]
            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            [reagent-material-ui.icons.info :refer [info]]
            ))


(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info {:fontSize "small"}]])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))
(defn last-contact-renderer [js-parm]
  (let [{row-data "rowData"} (js->clj js-parm)
        {last-contact "last-contact" last-app-contact "last-app-contact"} row-data]
    (r/as-element [:div
                   [:span (h-date/googDate->ger! last-contact)]
                   [:br]
                   (when last-app-contact [:span {:style {:color "blue"}} (h-date/googDate->ger! last-app-contact) " (App)"])])))

(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element [:span "-"]))))




(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !detail-search (r/cursor !st [:detail-search])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "CrowdTaskerUserList"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse rows)


         [:> rv/Column
          {:label     "TomId"
           :dataKey   "user-tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     70}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "user-firstName"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "user-lastName"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label        "Geburtstag"
           :dataKey      "user-birthday"
           :className    "bordered exampleColumn"
           :cellRenderer date-renderer
           :width        170}]
         [:> rv/Column
          {:label     "Email"
           :dataKey   "user-email"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Handy"
           :dataKey   "user-phoneNumber"
           :className "bordered exampleColumn"
           :width     170}]

         [:> rv/Column
          {:label     (r/as-element [:span "Letzter" [:br] "Kontakt"])
           :dataKey      "last-contact"
           :cellRenderer last-contact-renderer
           :className    "bordered exampleColumn"
           :width        100}]

         [:> rv/Column
          {:label        "Antwort"
           :dataKey      "response-time"
           :className    "bordered exampleColumn"
           :cellRenderer date-time-renderer
           :width        100}]


         [:> rv/Column
          {:label        (r/as-element [info])
           :dataKey      "user-tomId"
           :className    "bordered exampleColumn"
           :cellRenderer info-cell-renderer
           :width        70}]

         ]))))





(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn get-sort-filter-rows [rows sort_ reverse_ filter_]
  (js/console.log "get-sort-filter-rows = " rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (filter-fn rows filter_)
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))




(defn table-column [!st rows]
  (let [
        rows (get-sort-filter-rows rows (:sort @!st) (:reverse @!st) (:search @!st))
        cnt-rows (count rows)]

    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))


(defn get-table [!st rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st rows)]))

(defn get-it [member]
  (let [!st (r/atom {:sort :user-lastName :reverse true :search "" :show-delete false :manipulate-tomId nil :show-mail false})
        !event-detail-loaded? (r/cursor vstate/app-state [:event-detail-loaded])
        !event (r/cursor vstate/app-state [:selected-event])
        user (into {} (map (fn [m] [(:crowdtaskerEventMember-uuid m)
                                    (assoc (:crowdtaskerEventMember-user m)
                                      :last-contact (reduce (fn [c dev] (let [lc (h-date/parse-service-date! (:device-lastContact dev))]
                                                                          (if (and lc
                                                                                   (or (nil? c) (h-date/date>? lc c)))
                                                                            lc
                                                                            c)))
                                                            nil (get-in m [:crowdtaskerEventMember-user :device]))
                                      :last-app-contact (reduce (fn [c dev] (let [lc (h-date/parse-service-date! (:device-lastContact dev))]
                                                                          (if (and lc
                                                                                   (or (nil? c) (h-date/date>? lc c)))
                                                                            lc
                                                                            c)))
                                                            nil (filter (fn [dev] (not= (:device-deviceId dev) "browser")) (get-in m [:crowdtaskerEventMember-user :device])))
                                      :member-uuid (:crowdtaskerEventMember-uuid m)
                                      :response (:crowdtaskerEventMember-responseState m)
                                      :response-time (:crowdtaskerEventMember-responseTime m)
                                      :mission (:crowdtaskerEventMember-missionState m)
                                      )])
                           (filter (fn [e]
                                     (log/debug "filter " e "-" (:crowdtaskerEventMember-responseState e) " - " (:crowdtaskerEventMember-missionState e))
                                     (and true
                                          )) member)))
        get-name-fn (fn [uuid] (if uuid (str (get-in user [uuid :user-tomId]) ") " (get-in user [uuid :user-firstName]) " " (get-in user [uuid :user-lastName])) ""))
        ]
    (fn []
      (let [!map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
            !show-mail (r/cursor !st [:show-mail])
            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            !search (r/cursor !st [:search])
            !waiting? (r/cursor !st [:waiting])
            rows (get-sort-filter-rows user @!sort @!reverse @!search)]
        ;(log/debug "Event ROWS !!!!!!!!!!!!!!!!!!!!!!" (count rows))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style      {:height "calc(100% - 64px)" :minHeight "600px"}
          }

         [toe-modal/get-modal !map-userPopup]
         [are-you-sure-modal/are-you-sure-modal !show-mail (str "Willst allen Personen in dieser Liste (" (count user) ") ein Email senden?") "senden"
          (fn [] (log/debug "email " (count user)))]


         [mui/grid
          {:item  true
           :md    5
           :xs    9
           :style {:textAlign "left"}}
          [mui/text-field
           {:default-value (str @!search)
            :placeholder   "Suche in Liste ..."
            :style         {:width "250px" :display "inline-block"}
            :onChange      (h/wait-do !waiting? #(reset! !search %))
            :multiline     false}]
          (log/debug "Search " @!search)
          (when false                                       ; (> (count @!search) 0)
            [mui/button {:variant   "outlined"
                         :startIcon (r/as-element [close])
                         :onClick   (h/wait-do !waiting? (fn [_] (reset! !search "")))
                         :style     {:margin-left "5px" :margin-right "25px"}} ""])
          ]
         [mui/grid
          {:item  true
           :md    7
           :xs    3
           :style {:textAlign "right"}}
          ; [mui/button {:variant "outlined"
          ;              :startIcon (r/as-element [send])
          ;              :onClick #(reset! !show-mail true)
          ;              } "Email"]
          [mui/button {:variant   "outlined"
                       :startIcon (r/as-element [cloud-download])
                       :onClick   #(d-eventMember/open-csv (:crowdtaskerEvent-uuid @!event) nil nil)
                       } "Csv Export"]
          ]

         [mui/grid
          {:item  true
           :lg    12
           :xs    12
           :style {:textAlign "left"}}

          [(get-table !st rows)]
          ]

         ]
        )
      )))

























